import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import MainHall from "@/pages/MainHall";
import WelcomeDoor from "@/pages/WelcomeDoor";
import Architect from "@/pages/Architect";
import ArchitectGate from "@/pages/ArchitectGate";
import MyConstructions from "@/pages/MyConstructions";
import Account from "@/pages/Account";
import MyMaterialDetail from "@/pages/MyMaterialDetail";
import Admin from "@/pages/Admin";
import AdminMaterialPreview from "@/pages/AdminMaterialPreview";
import Library from "@/pages/Library";
import MaterialDetail from "@/pages/MaterialDetail";
import ProductView from "@/pages/ProductView";
import ProtectedMaterialDetail from "@/pages/ProtectedMaterialDetail";
import Placeholder from "@/pages/Placeholder";
import PublicOrderView from "@/pages/PublicOrderView";
import MOShell, { MOAccessProvider } from "@/components/masterOrder/MOShell";
import MasterOrderOverview from "@/pages/MasterOrderOverview";
import MasterOrderTesting from "@/pages/MasterOrderTesting";
import MasterOrderTestingFeedback from "@/pages/MasterOrderTestingFeedback";
import MOOrders from "@/pages/masterOrder/MOOrders";
import MOOrderNew from "@/pages/masterOrder/MOOrderNew";
import MOOrderDetail from "@/pages/masterOrder/MOOrderDetail";
import MOClients from "@/pages/masterOrder/MOClients";
import MOClientDetail from "@/pages/masterOrder/MOClientDetail";
import { MOCostings, MOCostingNew, MOCostingStudio } from "@/pages/masterOrder/MOCosting";
import MOIngredients from "@/pages/masterOrder/MOIngredients";
import MORecipes from "@/pages/masterOrder/MORecipes";
import MOPackaging from "@/pages/masterOrder/MOPackaging";
import MOPurchases from "@/pages/masterOrder/MOPurchases";
import MOProduction from "@/pages/masterOrder/MOProduction";
import MOProductionScenarios from "@/pages/masterOrder/MOProductionScenarios";
import MORecipeRecalc from "@/pages/masterOrder/MORecipeRecalc";
import MOCalendar from "@/pages/masterOrder/MOCalendar";
import MOProductCost from "@/pages/masterOrder/MOProductCost";
import MOBrandStudio from "@/pages/masterOrder/MOBrandStudio";
import ProgramsLanding from "@/pages/ProgramsLanding";
import ProgramDetail from "@/pages/ProgramDetail";
import AlmondLanding from "@/pages/AlmondLanding";
import GingerbreadLanding from "@/pages/GingerbreadLanding";
import BookEntry from "@/pages/book/BookEntry";
import BookContent from "@/pages/book/BookContent";
import BookReader from "@/pages/book/BookReader";
import ProductWorkspace from "@/pages/admin/ProductWorkspace";
import { EditorialHome, EditorialMaterialEditor } from "@/pages/admin/Editorial";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Client public Order page — NO auth, NO MOShell, NO redirect to /login */}
            <Route path="/order/:token" element={<PublicOrderView />} />

            <Route path="/" element={<WelcomeDoor />} />
            <Route path="/hall" element={<MainHall />} />
            <Route path="/architect" element={<ProtectedRoute><ArchitectGate /></ProtectedRoute>} />
            <Route path="/architect/:id" element={<ProtectedRoute><ArchitectGate /></ProtectedRoute>} />
            <Route path="/projects" element={<ProtectedRoute><MyConstructions /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
            <Route path="/account/materials/:id" element={<ProtectedRoute><MyMaterialDetail /></ProtectedRoute>} />

            <Route path="/library" element={<Library />} />
            <Route path="/library/:slug" element={<MaterialDetail />} />

            <Route path="/products/:slug" element={<ProtectedRoute><ProductView /></ProtectedRoute>} />
            <Route path="/products/:pslug/materials/:mslug" element={<ProtectedRoute><ProtectedMaterialDetail /></ProtectedRoute>} />

            <Route path="/master-order-testing" element={<MasterOrderTesting />} />
            <Route path="/master-order-testing/feedback" element={<MasterOrderTestingFeedback />} />

            <Route path="/master-order" element={<ProtectedRoute>
              <MOAccessProvider><MasterOrderOverview /></MOAccessProvider>
            </ProtectedRoute>} />
            <Route path="/master-order/orders" element={<ProtectedRoute><MOAccessProvider><MOOrders /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/orders/new" element={<ProtectedRoute><MOAccessProvider><MOOrderNew /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/orders/:orderId" element={<ProtectedRoute><MOAccessProvider><MOOrderDetail /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/clients" element={<ProtectedRoute><MOAccessProvider><MOClients /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/clients/:clientId" element={<ProtectedRoute><MOAccessProvider><MOClientDetail /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/costings" element={<ProtectedRoute><MOAccessProvider><MOCostings /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/costings/new" element={<ProtectedRoute><MOAccessProvider><MOCostingNew /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/costings/:costingId" element={<ProtectedRoute><MOAccessProvider><MOCostingStudio /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/ingredients" element={<ProtectedRoute><MOAccessProvider><MOIngredients /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/recipes" element={<ProtectedRoute><MOAccessProvider><MORecipes /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/recipe-recalc" element={<ProtectedRoute><MOAccessProvider><MORecipeRecalc /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/calendar" element={<ProtectedRoute><MOAccessProvider><MOCalendar /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/product-cost" element={<ProtectedRoute><MOAccessProvider><MOProductCost /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/brand-studio" element={<ProtectedRoute><MOAccessProvider><MOBrandStudio /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/packaging-items" element={<ProtectedRoute><MOAccessProvider><MOPackaging /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/purchases" element={<ProtectedRoute><MOAccessProvider><MOPurchases /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/production" element={<ProtectedRoute><MOAccessProvider><MOProduction /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/master-order/production/scenarios" element={<ProtectedRoute><MOAccessProvider><MOProductionScenarios /></MOAccessProvider></ProtectedRoute>} />
            <Route path="/media-studio" element={<ProtectedRoute>
              <Placeholder title="Медиа-студия" subtitle="Для соцсетей"
                description="Медиа-студия для создания контента и материалов для соцсетей." />
            </ProtectedRoute>} />
            <Route path="/programs" element={<ProgramsLanding />} />
            <Route path="/programs/almond" element={<AlmondLanding />} />
            <Route path="/programs/:slug" element={<ProgramDetail />} />
            <Route path="/gingerbread" element={<GingerbreadLanding />} />

            {/* Book — «Лаборатория превращений» */}
            <Route path="/book/:slug/entry" element={<BookEntry />} />
            <Route path="/book/:slug" element={<ProtectedRoute><BookContent /></ProtectedRoute>} />
            <Route path="/book/:slug/pages/:pageId" element={<ProtectedRoute><BookReader /></ProtectedRoute>} />

            <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
            <Route path="/admin/products/:productId" element={<AdminRoute><ProductWorkspace /></AdminRoute>} />
            <Route path="/admin/editorial" element={<AdminRoute><EditorialHome /></AdminRoute>} />
            <Route path="/admin/editorial/materials/:materialId" element={<AdminRoute><EditorialMaterialEditor /></AdminRoute>} />
            <Route path="/admin/preview/materials/:id" element={<AdminRoute><AdminMaterialPreview /></AdminRoute>} />
          </Routes>
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
